import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAgent } from "../../api/apiAgents";
import parseError from "../../utils/parseError";

const useForceDeleteAgent = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAgentAction, isPending } = useMutation({
        mutationFn: forceDeleteAgent,
        onSuccess: (res) => {
            const message = res?.message || "Agent permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["agents"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete agent");
        },
    });

    return { forceDeleteAgent: forceDeleteAgentAction, isPending };
};

export default useForceDeleteAgent;
